import { tw } from 'utils/classnames'

export interface RibbonProps {
  text: string | undefined
  color: string
  className?: string
}

export function Ribbon({ text, color, className }: RibbonProps) {
  return (
    <div
      style={{ '--ribbon-color': color } as React.CSSProperties}
      className={tw(
        'text-12 absolute -left-[10px] -top-3 isolate h-[30px] bg-[--ribbon-color] px-2 font-bold uppercase leading-[30px] tracking-[0.9px] text-white shadow-[0_2px_4px_0_rgba(0,0,0,0.4)]',
        "before:absolute before:-bottom-[10px] before:left-0 before:block before:size-0 before:border-[10px] before:border-l-0 before:border-t-0 before:border-transparent before:border-r-[--ribbon-color] before:content-['']",
        "after:absolute after:-right-[5px] after:top-0 after:inline-block after:border-y-[15px] after:border-r-[5px] after:border-[--ribbon-color] after:border-r-transparent after:content-[''] ",
        className,
      )}
    >
      {text}
    </div>
  )
}
